
module fdm.flightSegment {
    angular.module('fdm.flightSegment', []);
}